// store/modules/kanban.js
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  namespaced: true,
  state: {
    
    columModal: false,
    taskModal: false,
    isLoading: null,
    openTaskId: null,
    columns: [
       {
        id: uuidv4(),
        name: 'ОП / Оплата',
        name_ru: 'ОП / Оплата',
        name_kz: 'СБ / Төлем',
        name_en: 'Sales / Payment',
        color: '#50C700',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Типография(тираж)',
        name_ru: 'Типография(тираж)',
        name_kz: 'Баспа(тираж)',
        name_en: 'Printing (Circulation)',
        color: '#00C793',
        techcards: [],
      },
       {
        id: uuidv4(),
        name: 'Типография(ППР)',
        name_ru: 'Типография(ППР)',
        name_kz: 'Баспа(БКЖ)',
        name_en: 'Printing (WAP)',
        color: '#00C793',
        techcards: [],
      },      
      {
        id: uuidv4(),
        name: 'Склад(типография)',
        name_ru: 'Склад(типография)',
        name_kz: 'Қойма(баспа)',
        name_en: 'Stock(Printing House)',
        color: '#50C003',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Сдан',
        name_ru: 'Сдан',
        name_kz: 'Тапсырылған',
        name_en: 'Delivered',
        color: '#50C003',
        techcards: [],
      },
    ],
    columnsSmart: [
      {
        id: uuidv4(),
        name: 'ОП / Оплата',
        name_ru: 'ОП / Оплата',
        name_kz: 'СБ / Төлем',
        name_en: 'Sales / Payment',
        color: '#50C700',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Типография(тираж)',
        name_ru: 'Типография(тираж)',
        name_kz: 'Баспа(тираж)',
        name_en: 'Printing (Circulation)',
        color: '#00C793',
        techcards: [],
      },
       {
        id: uuidv4(),
        name: 'Типография(ППР)',
        name_ru: 'Типография(ППР)',
        name_kz: 'Баспа(БКЖ)',
        name_en: 'Printing (WAP)',
        color: '#00C793',
        techcards: [],
      },      
      {
        id: uuidv4(),
        name: 'Склад(типография)',
        name_ru: 'Склад(типография)',
        name_kz: 'Қойма(баспа)',
        name_en: 'Stock(Printing House)',
        color: '#50C003',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Сдан',
        name_ru: 'Сдан',
        name_kz: 'Тапсырылған',
        name_en: 'Delivered',
        color: '#50C003',
        techcards: [],
      },
    ],
    isEditTechCardModalVisible: false,
    isScoredModalVisible: false,
    isWarehouseTechCardModalVisible: false, // New modal for "Склад(типография)"
    selectedWarehouseTechCard: null, // Store tech card for warehouse modal
    selectedTechCardForEdit: null,
    selectedTechCardForScore: null,
  },
  getters: {
    columns: (state) => state.columns,
    columnsSmart: (state) => state.columnsSmart, // ← добавили
    isEditTechCardModalVisible: (state) => state.isEditTechCardModalVisible,
    isScoredModalVisible: (state) => state.isScoredModalVisible,
    selectedTechCardForEdit: (state) => state.selectedTechCardForEdit,
    selectedTechCardForScore: (state) => state.selectedTechCardForScore,
    editTechCardId: (state) => state.selectedTechCardForEdit?.id,
    isWarehouseTechCardModalVisible: (state) => state.isWarehouseTechCardModalVisible,
    selectedWarehouseTechCard: (state) => state.selectedWarehouseTechCard,
    whTechCardId: (state) => state.selectedWarehouseTechCard?.id,
    scoreTechCardId: (state) => state.selectedTechCardForScore?.id,
  },
  mutations: {
    openEditTechCardModal(state, techCard) {
      state.isEditTechCardModalVisible = true;
      state.selectedTechCardForEdit = techCard;  // Set the tech card data here
      console.log('Vuex mutation: tech card set for edit:', techCard);  // Debugging log
    },
    closeEditTechCardModal(state) {
      state.isEditTechCardModalVisible = false;
      state.selectedTechCardForEdit = null;
    },
    openScoreTechCardModal(state, techCard) {
      state.isScoredModalVisible = true;
      state.selectedTechCardForScore = techCard;  // Set the tech card data here
      console.log('Vuex mutation: tech card set for edit:', techCard);  // Debugging log
    },
    closeScoreTechCardModal(state) {
      state.isScoredModalVisible = false;
      state.selectedTechCardForScore = null;
    },
    openWarehouseTechCardModal(state, techCard) {
      state.isWarehouseTechCardModalVisible = true;
      state.selectedWarehouseTechCard = techCard; // Store the tech card data for the modal
    },
    closeWarehouseTechCardModal(state) {
      state.isWarehouseTechCardModalVisible = false;
      state.selectedWarehouseTechCard = null; // Clear the modal data
    },
    setColumns(state, offers) {
      state.columns.forEach((column) => (column.techcards = []));
      offers.forEach((offer) => {
        const printingStatuses = ['in process', 'accept', 'Invoice and contract sent','Request for invoice'];
        if (printingStatuses.includes(offer.status)) {
          state.columns.find((col) => col.name === 'ОП / Оплата').techcards.push(offer);
        }
        if (offer.status=='typo_finish') {
          state.columns.find((col) => col.name === 'Типография(тираж)').techcards.push(offer);
        }
        if (offer.status=='wap') {
          state.columns.find((col) => col.name === 'Типография(ППР)').techcards.push(offer);
        }
        if (offer.status=='stock') {
          state.columns.find((col) => col.name === 'Склад(типография)').techcards.push(offer);
        }
        if (offer.status=='done') {
          state.columns.find((col) => col.name === 'Сдан').techcards.push(offer);
        }
      });
    },
     setColumnsSmart(state, offers) {
  state.columnsSmart.forEach((column) => (column.techcards = []));
  offers.forEach((offer) => {
    const printingStatuses = ['in process', 'accept', 'Invoice and contract sent', 'Request for invoice'];
    if (printingStatuses.includes(offer.status)) {
      state.columnsSmart.find((col) => col.name === 'ОП / Оплата')?.techcards.push(offer);
    }
    if (offer.status == 'typo_finish') {
      state.columnsSmart.find((col) => col.name === 'Типография(тираж)')?.techcards.push(offer);
    }
    if (offer.status == 'wap') {
      state.columnsSmart.find((col) => col.name === 'Типография(ППР)')?.techcards.push(offer);
    }
    if (offer.status == 'stock') {
      state.columnsSmart.find((col) => col.name === 'Склад(типография)')?.techcards.push(offer);
    }
    if (offer.status == 'done') {
      state.columnsSmart.find((col) => col.name === 'Сдан')?.techcards.push(offer);
    }
  });
},
    updateTechCardState(state, updatedOffer) {
      // Удалим из всех колонок, если уже существует
      state.columns.forEach((col) => {
        col.techcards = col.techcards.filter(card => card.id !== updatedOffer.id);
      });
    
      // Определим колонку по статусу и добавим туда
      const statusToColumnName = {
        'in process': 'ОП / Оплата',
        'typo_finish': 'Типография(тираж)',
        'wap': 'Типография(ППР)',
        'stock': 'Склад(типография)',
        'done': 'Сдан',
      };
    
      const columnName = statusToColumnName[updatedOffer.status];
      const column = state.columns.find(col => col.name === columnName);
    
      if (column) {
        column.techcards.push(updatedOffer);
      } else {
        console.warn(`Column not found for status: ${updatedOffer.status}`);
      }
    },    
  
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setError(state, error) {
      toast.error(`Error: ${error}`, { timeout: 2000 });
    },
  },
  actions: {
    
    async openEditTechCardModal({ commit }, techCardId) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`https://apidash.smartpress.kz/api/tech-cards/${techCardId}`,
          {headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'  // Ensure this header is present
          }
      });
      console.log("Fetched Tech Card Data:", response.data);  // Debugging log
        commit('openEditTechCardModal', response.data);
      } catch (error) {
        console.error('Failed to fetch tech card data:', error);
        commit('openEditTechCardModal', { id: techCardId });  // If no data, open the modal with empty fields
      }
    },
    async openScoreTechCardModal({ commit }, techCardId) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`https://apidash.smartpress.kz/api/tech-cards/${techCardId}`,
          {headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'  // Ensure this header is present
          }
      });
      console.log("Fetched Tech Card Data:", response.data);  // Debugging log
        commit('openScoreTechCardModal', response.data);
      } catch (error) {
        console.error('Failed to fetch tech card data:', error);
        commit('openScoreTechCardModal', { id: techCardId });  // If no data, open the modal with empty fields
      }
    },
    async openWarehouseTechCardModal({ commit }, techCardId) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`https://apidash.smartpress.kz/api/tech-cards/${techCardId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        commit('openWarehouseTechCardModal', response.data); // Set the tech card in state
      } catch (error) {
        console.error('Failed to fetch tech card data:', error);
        commit('setError', error);
      }
    },
    closeWarehouseTechCardModal({ commit }) {
      commit('closeWarehouseTechCardModal'); // Close the modal
    },
    closeEditTechCardModal({ commit }) {
      commit('closeEditTechCardModal');
    },
    closeScoreTechCardModal({ commit }) {
      commit('closeScoreTechCardModal');
    },
    async fetchTechCards({ commit, dispatch }) {
      commit('setLoading', true);
      try {
        await dispatch('offers/fetchOffers', null, { root: true });
    
        let offers = this.getters['offers/offers'];
    
        // Получаем активного пользователя из localStorage
        const activeUser = JSON.parse(localStorage.getItem('activeUser')) || {};
        const userRole = activeUser.role_id || null;
    
        // Фильтруем офферы без техкарт для ОП (6) и Типография (7)
        if ([6, 8, 11].includes(userRole)) {
          offers = offers.filter(offer => offer.tech_card_count === 0);
        }
    
            offers = offers.filter(offer => offer.recipient_name !== 'ТОО "SMART UNIVERSITY PRESS"');
        // Передаём уже отфильтрованные офферы в setColumns
        commit('setColumns', offers);
      } catch (error) {
        commit('setError', error);
      } finally {
        commit('setLoading', false);
      }
    },  
    
    async fetchSmartUniversityTechCards({ commit, dispatch }) {
  commit('setLoading', true);
  try {
    await dispatch('offers/fetchOffers', null, { root: true });

    let offers = this.getters['offers/offers'];

    const activeUser = JSON.parse(localStorage.getItem('activeUser')) || {};
    const userRole = activeUser.role_id || null;

    // if ([6, 8, 11].includes(userRole)) {
    //   offers = offers.filter(offer => offer.tech_card_count === 0);
    // }

    // 🔽 фильтрация по организации
    const smartUniversityOffers = offers.filter(
      offer => offer.recipient_name === 'ТОО "SMART UNIVERSITY PRESS"'
    );
    

   commit('setColumnsSmart', smartUniversityOffers);
  } catch (error) {
    commit('setError', error);
  } finally {
    commit('setLoading', false);
  }
},
    async updateOfferKanban({ commit }, { updatedProperties }) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`https://apidash.smartpress.kz/api/offer/update-status`, updatedProperties, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'  // Ensure this header is present
          }
        });
    
        commit('updateTechCardState', response.data.offer);
        toast.success('Offer updated successfully', { timeout: 2000 });
      } catch (error) {
        commit('setError', error);
        toast.error('Failed to update Offer', { timeout: 2000 });
      }
    },
    async updateSignalEndDate({ commit }, { techcardId, signalEndDate }) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
          `https://apidash.smartpress.kz/api/tech-cards/${techcardId}/signal-end-date`,
          { signalEndDate },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
  
        commit('updateTechCardState', response.data.techcard); // Update the tech card state
        console.log('Signal end date updated successfully');
      } catch (error) {
        console.error('Error updating signal end date:', error);
        throw error; // Rethrow the error for the calling function to handle
      }
    },
  },
};
